// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.table-loader-container {
  position: relative;
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
}

.ratings-table-wrapper {
  max-height: 600px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-split-wrapper {
  display: flex;
  height: 100%;
  overflow: hidden;
}

/* Student info columns */
.fixed-columns {
  border-right: 3px solid #636161;
  flex: 0 0 auto;
  overflow: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}
.fixed-columns::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}
.fixed-columns .rating-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}
.fixed-columns .rating-table .as-link {
  background: transparent;
  border: none;
  color: #0000FF;
  cursor: pointer;
}
.fixed-columns .rating-table th,
.fixed-columns .rating-table td {
  padding: 4px 12px;
  border: 1px solid #A7A9AC;
}
.fixed-columns .rating-table td {
  height: 110px;
}
.fixed-columns .rating-table .group-cell {
  max-height: 100px;
  max-width: 140px;
  overflow: hidden;
}
.fixed-columns .rating-table .group-cell .group-text {
  font-size: 0.85rem;
  font-style: italic;
  font-weight: 500;
}
.fixed-columns .rating-table .group-cell .view-text {
  background-color: #c0def0;
  border-radius: 5px;
  font-weight: 500;
  padding: 2px 4px;
  width: fit-content;
}
.fixed-columns .rating-table .group-cell .note-tip-container {
  align-items: center;
  display: flex;
}
.fixed-columns .rating-table .group-cell .note-tip-container .note-text {
  margin-left: 4px;
}
.fixed-columns .rating-table th {
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: #c0def0;
  color: #0A4064;
  font-weight: 600;
  text-align: left;
  height: 76px;
}
.fixed-columns .rating-table th .icon-container {
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  margin-left: 5px;
  vertical-align: middle;
}
.fixed-columns .rating-table th .table-header-button {
  background: transparent;
  border: none;
}
.fixed-columns .rating-table th:first-child {
  border-top-left-radius: 12px;
}
.fixed-columns .rating-table tbody tr:nth-of-type(even) {
  background-color: white;
}

/* Rating columns that scroll horizontally */
.scrollable-columns {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: auto;
  max-height: 600px;
}
.scrollable-columns .rating-table {
  border-collapse: separate;
  border-spacing: 0;
  width: max-content;
}
.scrollable-columns .rating-table th,
.scrollable-columns .rating-table td {
  padding: 8px 12px;
  border: 1px solid #A7A9AC;
  width: 200px;
}
.scrollable-columns .rating-table td {
  height: 110px;
}
.scrollable-columns .rating-table .clickable-header {
  background: none;
  border: none;
  display: block;
  max-height: 20px;
  overflow: hidden;
  padding: 0;
  text-align: left;
  width: 100%;
}
.scrollable-columns .rating-table .clickable-header span {
  display: block;
  height: 20px;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.scrollable-columns .rating-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #c0def0;
  color: #0A4064;
  font-weight: 500;
  font-size: 12px;
  text-align: left;
  height: 76px;
}
.scrollable-columns .rating-table th:last-child {
  border-top-right-radius: 12px;
}
.scrollable-columns .rating-table select {
  border-radius: 5px;
  height: 32px;
  width: 88%;
}
.scrollable-columns .rating-table tbody tr:nth-of-type(even) {
  background-color: white;
}

.view-only-rating {
  border-radius: 5px;
  height: 32px;
  width: 83%;
  display: flex;
  align-items: center;
  padding-left: 4px;
  color: black;
}

.scrollable-columns .rating-table td.active-rating-col,
.scrollable-columns .rating-table th.active-rating-col {
  border-left: 4px solid #0dcaf0;
  border-right: 4px solid #0dcaf0;
}

.scrollable-columns .rating-table th.active-rating-col {
  background-color: #FAFAD2;
}

.rating-table thead th.active-rating-col {
  border-top: 3px solid #0dcaf0;
}

.rating-table tbody tr:last-child td.active-rating-col {
  border-bottom: 3px solid #0dcaf0;
}

.rating-table th {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.rating-blue {
  background-color: #1179ef;
}

.rating-green {
  background-color: #C7CC68;
}

.rating-orange {
  background-color: #FEBF31;
}

.rating-red {
  background-color: #e27319;
}

.rating-excluded {
  background-color: #444343;
  color: white;
}

.rating-column-desc-title {
  color: #0A4064;
  margin-bottom: 2px;
}

.rating-column-description-wrapper {
  overflow: hidden;
  max-height: 500px;
  opacity: 1;
  transform: translateY(0);
  transition: max-height 200ms ease, opacity 200ms ease, transform 200ms ease;
}
.rating-column-description-wrapper.hide {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
  pointer-events: none;
}

.rating-column-description {
  background-color: #FAFAD2;
  border: 3px solid #0dcaf0;
  border-radius: 10px;
  padding: 16px;
  margin: 0px 0px 24px 0px;
}
.rating-column-description strong {
  display: block;
  font-size: 1.1em;
  margin-bottom: 4px;
}

.hierarchy-text-wrapper {
  font-size: 0.8rem;
}

.hierarchy-text {
  font-weight: 600;
  margin-bottom: 4px;
  margin-right: 8px;
}

.rating-table-btn-group {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-left: -10px;
  margin-right: -26px;
}
.rating-table-btn-group .column-nav {
  display: flex;
  justify-content: flex-end;
  padding: 8px 16px;
}

.student-criteria-comment-input {
  border-radius: 5px;
  padding: 8px;
  width: 100%;
}

.save-btn-ratings {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  width: 100%;
}

.rating-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.comment-icon {
  font-size: 1.2rem;
  color: #0A4064;
  cursor: pointer;
}

.rating-red-icon,
.rating-orange-icon {
  font-size: 1.2rem;
  color: #e27319;
  cursor: pointer;
}

.rating-blue-comment {
  border: 2px solid #1179ef;
  border-radius: 3px;
  padding: 2px 4px;
}

.rating-green-comment {
  border: 2px solid #C7CC68;
  border-radius: 3px;
  padding: 2px 4px;
}

.rating-orange-comment {
  border: 2px solid #FEBF31;
  border-radius: 3px;
  padding: 2px 4px;
}

.rating-red-comment {
  border: 2px solid #e27319;
  border-radius: 3px;
  padding: 2px 4px;
}

.rating-comment-model {
  color: #444343;
}
.rating-comment-model .section-spacing {
  margin-bottom: 1rem;
}
.rating-comment-model .error-container {
  background-color: #FEBF31;
  border: 1.5px solid #FEBF31;
  border-radius: 5px;
  margin-left: 25%;
  margin-right: 25%;
  padding: 12px;
  text-align: center;
}
.rating-comment-model .error-container .error-text {
  color: black;
  font-size: 1rem;
  font-weight: 600;
}

.no-sles-available {
  background-color: white;
  border-radius: 10px;
  font-weight: 500;
  padding: 24px;
  text-align: center;
}

.no-content-available-wrapper {
  background-color: white;
  border: 1px solid #636161;
  border-radius: 5px;
  padding: 24px;
}
.no-content-available-wrapper .no-content-text {
  font-weight: 450;
}

.comment-icon--disabled {
  opacity: 0.5;
  cursor: default;
}

.fluency-wpm-grid-cell {
  align-items: center;
  display: flex;
  gap: 6px;
  white-space: nowrap;
}

.fluency-wpm-grid-input {
  width: 56px;
  padding: 4px 6px;
  border: 1px solid #808080;
  border-radius: 4px;
  flex-shrink: 0;
}

.fluency-wpm-grid-unit {
  color: #444343;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
}

.fluency-wpm-field {
  background: #fff;
  border: 1px solid #D1D3D4;
  border-left: 4px solid #0669B3;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 12px 16px;
}
.fluency-wpm-field__label {
  font-size: 16px;
  font-weight: 700;
}
.fluency-wpm-field__stem {
  color: #444343;
  font-size: 14px;
  margin: 8px 0 12px;
}
.fluency-wpm-field__guidance-block {
  background: #EDF0F1;
  border: 1px solid #D1D3D4;
  border-radius: 6px;
  margin: 0 0 4px;
  padding: 8px 12px;
}
.fluency-wpm-field__guidance-label {
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.fluency-wpm-field__guidance {
  color: #444343;
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/RatingTable.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAFA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;AAKJ;;AAFA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAKJ;;AAFA;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AAKJ;;AAFA,yBAAA;AACA;EACI,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,wBAAA;EAEA,WAAA;AAIJ;AAHI;EACI,aAAA;EACA,0BAAA;AAKR;AAFI;EACI,yBAAA;EACA,iBAAA;EACA,WAAA;AAIR;AAFQ;EACI,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAIZ;AADQ;;EAEI,iBAAA;EACA,yBAAA;AAGZ;AAAQ;EACI,aAAA;AAEZ;AACQ;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;AACZ;AACY;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;AAChB;AAEY;EACI,yBDvEJ;ECwEI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAAhB;AAGY;EACI,mBAAA;EACA,aAAA;AADhB;AAGgB;EACI,gBAAA;AADpB;AAMQ;EACI,gBAAA;EACA,MAAA;EACA,UAAA;EACA,yBD5FA;EC6FA,cD/FF;ECgGE,gBAAA;EACA,gBAAA;EACA,YAAA;AAJZ;AAMY;EACI,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AAJhB;AAOY;EACI,uBAAA;EACA,YAAA;AALhB;AAQY;EACI,4BAAA;AANhB;AAWI;EACI,uBAAA;AATR;;AAaA,4CAAA;AACA;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAVJ;AAYI;EACI,yBAAA;EACA,iBAAA;EACA,kBAAA;AAVR;AAYQ;;EAEI,iBAAA;EACA,yBAAA;EACA,YAAA;AAVZ;AAaQ;EACI,aAAA;AAXZ;AAcQ;EACI,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AAZZ;AAcY;EACI,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAZhB;AAgBQ;EACI,gBAAA;EACA,MAAA;EACA,UAAA;EACA,yBDzKA;EC0KA,cD5KF;EC6KE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAdZ;AAgBY;EACI,6BAAA;AAdhB;AAmBQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;AAjBZ;AAsBI;EACI,uBAAA;AApBR;;AAwBA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AArBJ;;AAwBA;;EAEI,8BAAA;EACA,+BAAA;AArBJ;;AAwBA;EACI,yBDtMW;ACiLf;;AAwBA;EACI,6BAAA;AArBJ;;AAwBA;EACI,gCAAA;AArBJ;;AAwBA;EACI,yCAAA;AArBJ;;AAwBA;EACI,yBA5OU;AAuNd;;AAwBA;EACI,yBA/OW;AA0Nf;;AAwBA;EACI,yBDhOQ;AC2MZ;;AAwBA;EACI,yBArPS;AAgOb;;AAwBA;EACI,yBD/NK;ECgOL,YAAA;AArBJ;;AAwBA;EACI,cD3PM;EC4PN,kBAAA;AArBJ;;AAwBA;EACI,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;EACA,2EAAA;AArBJ;AAuBI;EACI,aAAA;EACA,UAAA;EACA,4BAAA;EACA,oBAAA;AArBR;;AAyBA;EACI,yBD/PW;ECgQX,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;AAtBJ;AAwBI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;AAtBR;;AA0BA;EACI,iBAAA;AAvBJ;;AA0BA;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;AAvBJ;;AA0BA;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AAvBJ;AAyBI;EACI,aAAA;EACA,yBAAA;EACA,iBAAA;AAvBR;;AA2BA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AAxBJ;;AA2BA;EACI,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AAxBJ;;AA2BA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAxBJ;;AA2BA;EACI,iBAAA;EACA,cDzUM;EC0UN,eAAA;AAxBJ;;AA2BA;;EAEI,iBAAA;EACA,cAnVS;EAoVT,eAAA;AAxBJ;;AA2BA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;AAxBJ;;AA2BA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;AAxBJ;;AA2BA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;AAxBJ;;AA2BA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;AAxBJ;;AA2BA;EACI,cDtVK;AC8TT;AA0BI;EACI,mBAAA;AAxBR;AA2BI;EACI,yBDtWI;ECuWJ,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AAzBR;AA2BQ;EACI,YAAA;EACA,eAAA;EACA,gBAAA;AAzBZ;;AA8BA;EACI,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AA3BJ;;AA8BA;EACI,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AA3BJ;AA6BI;EACI,gBAAA;AA3BR;;AA+BA;EACI,YAAA;EACA,eAAA;AA5BJ;;AA+BA;EACI,mBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AA5BJ;;AA+BA;EACI,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AA5BJ;;AA+BA;EACI,cDrZK;ECsZL,eAAA;EACA,gBAAA;EACA,gBAAA;AA5BJ;;AA+BA;EACI,gBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AA5BJ;AA8BI;EACI,eAAA;EACA,gBAAA;AA5BR;AA+BI;EACI,cDzaC;EC0aD,eAAA;EACA,kBAAA;AA7BR;AAgCI;EACI,mBDrbA;ECsbA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AA9BR;AAiCI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AA/BR;AAkCI;EACI,cD/bC;ECgcD,eAAA;EACA,gBAAA;EACA,SAAA;AAhCR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n$rating-blue: #1179ef;\n$rating-green: #C7CC68;\n$rating-orange: $important;\n$rating-red: #e27319;\n\n.table-loader-container {\n    position: relative;\n    width: 100%;\n    height: 400px; // adjust to roughly match the table height\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba(255, 255, 255, 0.8);\n    border-radius: 8px;\n}\n\n.ratings-table-wrapper {\n    max-height: 600px;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.table-split-wrapper {\n    display: flex;\n    height: 100%;\n    overflow: hidden;\n}\n\n/* Student info columns */\n.fixed-columns {\n    border-right: 3px solid $grey4;\n    flex: 0 0 auto;\n    overflow: hidden;\n    overflow-y: auto;\n    scrollbar-width: none;\n    /* Firefox */\n    -ms-overflow-style: none;\n\n    /* IE 10+ */\n    &::-webkit-scrollbar {\n        display: none;\n        /* Chrome, Safari, Opera */\n    }\n\n    .rating-table {\n        border-collapse: separate;\n        border-spacing: 0;\n        width: 100%;\n\n        .as-link {\n            background: transparent;\n            border: none;\n            color: #0000FF;\n            cursor: pointer;\n        }\n\n        th,\n        td {\n            padding: 4px 12px;\n            border: 1px solid $grey2;\n        }\n\n        td {\n            height: 110px;\n        }\n\n        .group-cell {\n            max-height: 100px;\n            max-width: 140px;\n            overflow: hidden;\n\n            .group-text {\n                font-size: 0.85rem;\n                font-style: italic;\n                font-weight: 500;\n            }\n\n            .view-text {\n                background-color: $pale-blue;\n                border-radius: 5px;\n                font-weight: 500;\n                padding: 2px 4px;\n                width: fit-content;\n            }\n\n            .note-tip-container {\n                align-items: center;\n                display: flex;\n\n                .note-text {\n                    margin-left: 4px;\n                }\n            }\n        }\n\n        th {\n            position: sticky;\n            top: 0;\n            z-index: 3;\n            background-color: $pale-blue;\n            color: $dk-blue;\n            font-weight: 600;\n            text-align: left;\n            height: 76px;\n\n            .icon-container {\n                cursor: pointer;\n                display: inline-flex;\n                flex-direction: column;\n                margin-left: 5px;\n                vertical-align: middle;\n            }\n\n            .table-header-button {\n                background: transparent;\n                border: none;\n            }\n\n            &:first-child {\n                border-top-left-radius: 12px;\n            }\n        }\n    }\n\n    .rating-table tbody tr:nth-of-type(even) {\n        background-color: white;\n    }\n}\n\n/* Rating columns that scroll horizontally */\n.scrollable-columns {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    overflow-x: auto;\n    max-height: 600px;\n\n    .rating-table {\n        border-collapse: separate;\n        border-spacing: 0;\n        width: max-content;\n\n        th,\n        td {\n            padding: 8px 12px;\n            border: 1px solid $grey2;\n            width: 200px;\n        }\n\n        td {\n            height: 110px;\n        }\n\n        .clickable-header {\n            background: none;\n            border: none;\n            display: block;\n            max-height: 20px;\n            overflow: hidden;\n            padding: 0;\n            text-align: left;\n            width: 100%;\n\n            span {\n                display: block;\n                height: 20px;\n                max-width: 160px;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n            }\n        }\n\n        th {\n            position: sticky;\n            top: 0;\n            z-index: 2;\n            background-color: $pale-blue;\n            color: $dk-blue;\n            font-weight: 500;\n            font-size: 12px;\n            text-align: left;\n            height: 76px;\n\n            &:last-child {\n                border-top-right-radius: 12px;\n            }\n        }\n\n\n        select {\n            border-radius: 5px;\n            height: 32px;\n            width: 88%;\n        }\n\n    }\n\n    .rating-table tbody tr:nth-of-type(even) {\n        background-color: white;\n    }\n}\n\n.view-only-rating {\n    border-radius: 5px;\n    height: 32px;\n    width: 83%;\n    display: flex;\n    align-items: center;\n    padding-left: 4px;\n    color: black;\n}\n\n.scrollable-columns .rating-table td.active-rating-col,\n.scrollable-columns .rating-table th.active-rating-col {\n    border-left: 4px solid #0dcaf0;\n    border-right: 4px solid #0dcaf0;\n}\n\n.scrollable-columns .rating-table th.active-rating-col {\n    background-color: $lt-highlight;\n}\n\n.rating-table thead th.active-rating-col {\n    border-top: 3px solid #0dcaf0;\n}\n\n.rating-table tbody tr:last-child td.active-rating-col {\n    border-bottom: 3px solid #0dcaf0;\n}\n\n.rating-table th {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.rating-blue {\n    background-color: $rating-blue;\n}\n\n.rating-green {\n    background-color: $rating-green;\n}\n\n.rating-orange {\n    background-color: $rating-orange;\n}\n\n.rating-red {\n    background-color: $rating-red;\n}\n\n.rating-excluded {\n    background-color: $grey4a;\n    color: white;\n}\n\n.rating-column-desc-title {\n    color: $dk-blue;\n    margin-bottom: 2px;\n}\n\n.rating-column-description-wrapper {\n    overflow: hidden;\n    max-height: 500px;\n    opacity: 1;\n    transform: translateY(0);\n    transition: max-height 200ms ease, opacity 200ms ease, transform 200ms ease;\n\n    &.hide {\n        max-height: 0;\n        opacity: 0;\n        transform: translateY(-10px);\n        pointer-events: none;\n    }\n}\n\n.rating-column-description {\n    background-color: $lt-highlight;\n    border: 3px solid #0dcaf0;\n    border-radius: 10px;\n    padding: 16px;\n    margin: 0px 0px 24px 0px;\n\n    strong {\n        display: block;\n        font-size: 1.1em;\n        margin-bottom: 4px;\n    }\n}\n\n.hierarchy-text-wrapper {\n    font-size: 0.8rem;\n}\n\n.hierarchy-text {\n    font-weight: 600;\n    margin-bottom: 4px;\n    margin-right: 8px;\n}\n\n.rating-table-btn-group {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-left: -10px;\n    margin-right: -26px;\n\n    .column-nav {\n        display: flex;\n        justify-content: flex-end;\n        padding: 8px 16px;\n    }\n}\n\n.student-criteria-comment-input {\n    border-radius: 5px;\n    padding: 8px;\n    width: 100%;\n}\n\n.save-btn-ratings {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 16px;\n    width: 100%;\n}\n\n.rating-cell {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.comment-icon {\n    font-size: 1.2rem;\n    color: $dk-blue;\n    cursor: pointer;\n}\n\n.rating-red-icon,\n.rating-orange-icon {\n    font-size: 1.2rem;\n    color: $rating-red;\n    cursor: pointer;\n}\n\n.rating-blue-comment {\n    border: 2px solid $rating-blue;\n    border-radius: 3px;\n    padding: 2px 4px;\n}\n\n.rating-green-comment {\n    border: 2px solid $rating-green;\n    border-radius: 3px;\n    padding: 2px 4px;\n}\n\n.rating-orange-comment {\n    border: 2px solid $rating-orange;\n    border-radius: 3px;\n    padding: 2px 4px;\n}\n\n.rating-red-comment {\n    border: 2px solid $rating-red;\n    border-radius: 3px;\n    padding: 2px 4px;\n}\n\n.rating-comment-model {\n    color: $grey4a;\n\n    .section-spacing {\n        margin-bottom: 1rem;\n    }\n\n    .error-container {\n        background-color: $important;\n        border: 1.5px solid $important;\n        border-radius: 5px;\n        margin-left: 25%;\n        margin-right: 25%;\n        padding: 12px;\n        text-align: center;\n\n        .error-text {\n            color: black;\n            font-size: 1.0rem;\n            font-weight: 600;\n        }\n    }\n}\n\n.no-sles-available {\n    background-color: white;\n    border-radius: 10px;\n    font-weight: 500;\n    padding: 24px;\n    text-align: center;\n}\n\n.no-content-available-wrapper {\n    background-color: white;\n    border: 1px solid $grey4;\n    border-radius: 5px;\n    padding: 24px;\n\n    .no-content-text {\n        font-weight: 450;\n    }\n}\n\n.comment-icon--disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.fluency-wpm-grid-cell {\n    align-items: center;\n    display: flex;\n    gap: 6px;\n    white-space: nowrap;\n}\n\n.fluency-wpm-grid-input {\n    width: 56px;\n    padding: 4px 6px;\n    border: 1px solid $grey3;\n    border-radius: 4px;\n    flex-shrink: 0;\n}\n\n.fluency-wpm-grid-unit {\n    color: $grey4a;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.fluency-wpm-field {\n    background: #fff;\n    border: 1px solid $grey1;\n    border-left: 4px solid $pearl-blue;\n    border-radius: 8px;\n    margin-bottom: 16px;\n    padding: 12px 16px;\n\n    &__label {\n        font-size: 16px;\n        font-weight: 700;\n    }\n\n    &__stem {\n        color: $grey4a;\n        font-size: 14px;\n        margin: 8px 0 12px;\n    }\n\n    &__guidance-block {\n        background: $grey0;\n        border: 1px solid $grey1;\n        border-radius: 6px;\n        margin: 0 0 4px;\n        padding: 8px 12px;\n    }\n\n    &__guidance-label {\n        font-size: 12px;\n        font-weight: 700;\n        margin-bottom: 4px;\n        text-transform: uppercase;\n        letter-spacing: 0.02em;\n    }\n\n    &__guidance {\n        color: $grey4a;\n        font-size: 13px;\n        line-height: 1.4;\n        margin: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
